var _effectorFileName = "/builds/gmini/front-ui-kit/src/Checkbox/Checkbox.styled.ts";
import styled, { css } from 'styled-components';
export const CheckboxContainer = styled.label`
  display: flex;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};

  & path {
    transition: all ease-out 0.1s;
  }

  &:hover {
    & path {
      ${props => !props.disabled && css`
          fill: ${props.hoverColor};
        `};
    }
  }

  ${props => !props.disabled && props.hover && css`
      & svg path {
        fill: ${props.hoverColor};
      }
    `}
`;
export const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
})`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const CheckboxIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;